export const normalizeBusinessSlug = (value: unknown) => {
  if (typeof value !== "string") {
    return ""
  }

  return value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
}

export const getBusinessSlugLookupValues = (value: unknown) => {
  if (typeof value !== "string") {
    return []
  }

  return Array.from(new Set([value.trim(), normalizeBusinessSlug(value)].filter(Boolean)))
}
